// This optional code is used to register a service worker.
// register() is not called by default.

// This lets the app load faster on subsequent visits in production, and gives
// it offline capabilities. However, it also means that developers (and users)
// will only see deployed updates on subsequent visits to a page, after all the
// existing tabs open on the page have been closed, since previously cached
// resources are updated in the background.

// To learn more about the benefits of this model and instructions on how to
// opt-in, read https://bit.ly/CRA-PWA

//const applicationServerKey = `MIICNzCCAd0CCQDDGLiA/u+qlDAKBggqhkjOPQQDAjCBpDELMAkGA1UEBhMCQVUxEzARBgNVBAgMClF1ZWVuc2xhbmQxEDAOBgNVBAcMB0J1bmRhbGwxEjAQBgNVBAoMCWFpcnRlYWNocjENMAsGA1UECwwEdGVjaDEkMCIGA1UEAwwbYXBwLWRldi5ucC5haXJ0ZWFjaHIuY29tLmF1MSUwIwYJKoZIhvcNAQkBFhZqYXJvbUBhaXJ0ZWFjaHIuY29tLmF1MB4XDTIzMDcxODEzMzg0N1oXDTI0MDcxNzEzMzg0N1owgaQxCzAJBgNVBAYTAkFVMRMwEQYDVQQIDApRdWVlbnNsYW5kMRAwDgYDVQQHDAdCdW5kYWxsMRIwEAYDVQQKDAlhaXJ0ZWFjaHIxDTALBgNVBAsMBHRlY2gxJDAiBgNVBAMMG2FwcC1kZXYubnAuYWlydGVhY2hyLmNvbS5hdTElMCMGCSqGSIb3DQEJARYWamFyb21AYWlydGVhY2hyLmNvbS5hdTBWMBAGByqGSM49AgEGBSuBBAAKA0IABGtKFub5b62FLBulcsziMncz/6vfWvkamWgQw03NpCWPH6OEKWwf5zb7nxzcrYyxrJDTEKttuBTr04HBsDLENmEwCgYIKoZIzj0EAwIDSAAwRQIgbnz3DVcd88+JQ9D4iykMScvXSxNSc47S0QiXLYHKICECIQD/6VjwmBwemzX435Oj9tPYWMikY0q/A6OOkmVw8BHpnQ==`;

//const applicationServerKey = 'BgUrgQQACg==';

// const applicationServerKey = `MIICNzCCAd0CCQDDGLiA/u+qlDAKBggqhkjOPQQDAjCBpDELMAkGA1UEBhMCQVUx
// EzARBgNVBAgMClF1ZWVuc2xhbmQxEDAOBgNVBAcMB0J1bmRhbGwxEjAQBgNVBAoM
// CWFpcnRlYWNocjENMAsGA1UECwwEdGVjaDEkMCIGA1UEAwwbYXBwLWRldi5ucC5h
// aXJ0ZWFjaHIuY29tLmF1MSUwIwYJKoZIhvcNAQkBFhZqYXJvbUBhaXJ0ZWFjaHIu
// Y29tLmF1MB4XDTIzMDcxODEzMzg0N1oXDTI0MDcxNzEzMzg0N1owgaQxCzAJBgNV
// BAYTAkFVMRMwEQYDVQQIDApRdWVlbnNsYW5kMRAwDgYDVQQHDAdCdW5kYWxsMRIw
// EAYDVQQKDAlhaXJ0ZWFjaHIxDTALBgNVBAsMBHRlY2gxJDAiBgNVBAMMG2FwcC1k
// ZXYubnAuYWlydGVhY2hyLmNvbS5hdTElMCMGCSqGSIb3DQEJARYWamFyb21AYWly
// dGVhY2hyLmNvbS5hdTBWMBAGByqGSM49AgEGBSuBBAAKA0IABGtKFub5b62FLBul
// csziMncz/6vfWvkamWgQw03NpCWPH6OEKWwf5zb7nxzcrYyxrJDTEKttuBTr04HB
// sDLENmEwCgYIKoZIzj0EAwIDSAAwRQIgbnz3DVcd88+JQ9D4iykMScvXSxNSc47S
// 0QiXLYHKICECIQD/6VjwmBwemzX435Oj9tPYWMikY0q/A6OOkmVw8BHpnQ==`;

const VAPIDKey = {
    'publicKey':
        'BCZ_BHSRVKNs9BMI0nUFuW7VXhGjQNNZ2bx4g9mdvSK1W-G2dcRAIeQBy2zdxMleogSYMLDljmwFLyr3knwqYq8',
    'privateKey': '6eP5IGNEF2AmYywMWbyuOfizu-VBHJZainodognyg3U',
};

function askPermission() {
    //returns 'granted', 'default' or 'denied'
    return new Promise(function (resolve, reject) {
        const permissionResult = Notification.requestPermission(function (
            result
        ) {
            resolve(result);
        });

        if (permissionResult) {
            permissionResult.then(resolve, reject);
        }
    }).then(function (permissionResult) {
        if (permissionResult !== 'granted') {
            throw new Error("We weren't granted permission.");
        }
    });
}

const isLocalhost = Boolean(
    window.location.hostname === 'localhost' ||
        // [::1] is the IPv6 localhost address.
        window.location.hostname === '[::1]' ||
        // 127.0.0.1/8 is considered localhost for IPv4.
        window.location.hostname.match(
            /^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/
        )
);

export function register(config) {
    console.log('Service Worker registration process');
    if (process.env.NODE_ENV === 'production' && 'serviceWorker' in navigator) {
        // The URL constructor is available in all browsers that support SW.
        const publicUrl = process.env.PUBLIC_URL
            ? new URL(process.env.PUBLIC_URL, window.location.href)
            : new URL('/', 'http://localhost:3000');

        // const publicUrl = new URL(process.env.PUBLIC_URL);
        if (publicUrl.origin !== window.location.origin) {
            // Our service worker won't work if PUBLIC_URL is on a different origin
            // from what our page is served on. This might happen if a CDN is used to
            // serve assets; see https://github.com/facebook/create-react-app/issues/2374
            return;
        }

        window.addEventListener('load', () => {
            console.log('fired load event');
            const swUrl = process.env.PUBLIC_URL
                ? `${process.env.PUBLIC_URL}/service-worker.js`
                : `${window.location.origin}/service-worker.js`;

            if (isLocalhost) {
                // This is running on localhost. Let's check if a service worker still exists or not.
                checkValidServiceWorker(swUrl, config);

                // Add some additional logging to localhost, pointing developers to the
                // service worker/PWA documentation.
                navigator.serviceWorker.ready.then(() => {
                    console.log(
                        'This web app is being served cache-first by a service ' +
                            'worker. To learn more, visit https://bit.ly/CRA-PWA'
                    );
                });
            } else {
                // Is not localhost. Just register service worker
                registerValidSW(swUrl, config);
            }
        });
    }
}

function registerValidSW(swUrl, config) {
    //Get the browsers navigator API and register the service worker
    //Returns a service worker registration object https://developer.mozilla.org/en-US/docs/Web/API/ServiceWorkerRegistration
    navigator.serviceWorker
        .register(swUrl)
        .then(async registration => {
            const manifest = await fetch(
                `${registration.scope}/manifest.json`
            ).then(response => {
                return response.json();
            });
            const version = manifest.appVersion;

            if (!localStorage.getItem('version')) {
                localStorage.setItem('version', version);
            } else {
                if (localStorage.getItem('version') !== version) {
                    if (
                        await window.confirm(
                            'New Version of the App available. Click ok to install'
                        )
                    ) {
                        localStorage.setItem('version', version);
                        const keys = await caches.keys();
                        for (const key of keys) {
                            if (key.includes(registration.scope)) {
                                await caches.delete(key);
                            }
                        }
                        window.location.reload();
                    } else {
                        localStorage.setItem('version', version);
                    }
                }
            }
            console.log('Kept running after the prompt');

            registration.onupdatefound = () => {
                console.log('Registration update found');
                const installingWorker = registration.installing;
                if (installingWorker == null) {
                    return;
                }
                installingWorker.onstatechange = () => {
                    console.log('Registration state change found');
                    if (installingWorker.state === 'installed') {
                        console.log('New registration installed');
                        if (navigator.serviceWorker.controller) {
                            console.log('Service Worker controller exists');
                            // At this point, the updated precached content has been fetched,
                            // but the previous service worker will still serve the older
                            // content until all client tabs are closed.
                            console.log(
                                'New content is available and will be used when all ' +
                                    'tabs for this page are closed. See https://bit.ly/CRA-PWA.'
                            );

                            // Execute callback
                            if (config && config.onUpdate) {
                                config.onUpdate(registration);
                            }
                        } else {
                            // At this point, everything has been precached.
                            // It's the perfect time to display a
                            // "Content is cached for offline use." message.
                            console.log('Content is cached for offline use.');

                            // Execute callback
                            if (config && config.onSuccess) {
                                config.onSuccess(registration);
                            }
                        }
                    }
                };
            };
        })
        .catch(error => {
            console.error('Error during service worker registration:', error);
        });
}

function checkValidServiceWorker(swUrl, config) {
    // Go get the service worker URL file again in a fetch request
    fetch(swUrl)
        .then(response => {
            // Ensure we got the service worker downloaded and that it is really getting a JS file.
            const contentType = response.headers.get('content-type');
            if (
                response.status === 404 ||
                (contentType != null &&
                    contentType.indexOf('javascript') === -1)
            ) {
                // Check if the service worker is ready. If we find one then unregister it because the service worker file was not found anymore.
                // Could be the result of poor coding or a clash in app. Now Reload the page.
                navigator.serviceWorker.ready.then(registration => {
                    registration.unregister().then(() => {
                        window.location.reload();
                    });
                });
            } else {
                // Service worker found. Proceed as normal.
                registerValidSW(swUrl, config);
            }
        })
        .catch(() => {
            console.log(
                'No internet connection found. App is running in offline mode.'
            );
        });
}

export function unregister() {
    if ('serviceWorker' in navigator) {
        navigator.serviceWorker.ready
            .then(registration => {
                registration.unregister();
            })
            .catch(error => {
                console.error(error.message);
            });
    }
}
